import FormattedMessage from 'I18n/components/FormattedMessage';
import { Root, SidePanel, SidePanelContent } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import styled, { isTrellisTheme, useTheme, css } from 'foundations-theming/utils';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { getFlowKey } from '../routing/getFlowKey';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledText = styled.div.withConfig({
  displayName: "SidePanelLayoutViewContainer__StyledText",
  componentId: "a2bgyt-0"
})(({
  theme
}) => {
  return css(["font-weight:200;font-size:", ";line-height:", ";margin-top:", ";"], theme.typography['heading-1000'].fontSize, theme.typography['heading-1000'].lineHeight, theme.space['200']);
});
const shouldShowIllustration = currentStep => {
  return [Step.LandingPage, Step.CodeVerification, Step.Password, Step.ResendEmail, Step.Name, Step.RecaptchaCreationError].includes(currentStep);
};
export const SidePanelLayoutViewContainer = ({
  children,
  currentStepNumber,
  totalSteps
}) => {
  const {
    isDesktop
  } = useResponsiveness();
  const activeFlow = getFlowKey();
  const {
    currentStep
  } = useCurrentStep();
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const isPreVerificationStep = shouldShowIllustration(currentStep);
  return /*#__PURE__*/_jsxs(Root, {
    currentStepNumber: currentStepNumber,
    totalSteps: totalSteps,
    children: [isDesktop && /*#__PURE__*/_jsx(SidePanel, {
      children: /*#__PURE__*/_jsxs(SidePanelContent, {
        children: [isPreVerificationStep && /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "1600",
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: isTrellisThemeEnabled ? '136px' : '200px',
            name: isTrellisThemeEnabled ? 'success-quota-met' : 'content-strategy',
            width: isTrellisThemeEnabled ? '136px' : '200px'
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockStart: isTrellisThemeEnabled ? '500' : '100',
            textAlign: "center",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `sidepanel.hubType.${activeFlow}.title`
            })
          })]
        }), !isPreVerificationStep && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "sidepanel.title"
            })
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            marginBlockStart: "600",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "sidepanel.description"
            })
          })]
        })]
      })
    }), children]
  });
};